<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <KTCodePreview v-bind:title="'Forum Alumni'">
                     <template v-slot:body>
                        <div class="col-md-12">
                            <v-data-table :headers="headers_forum" :items="forum_alumni" >
                                <template v-slot:item.lampiran="{item}">
                                    <span @click="downloadItem(item.lampiran)" class="cursor-hand">{{ item.lampiran }}</span>
                                </template>
                                <template v-slot:item.action="{item}">
                                    <ButtonComponent colors="#3751E4" name="view" v-b-modal.modal_get
                                                    @click.native="openModal(item)" 
                                                    dataTitleTooltip="View" />
                                </template>
                            </v-data-table>
                        </div>
                     </template>
                </KTCodePreview>
            </div>
        </div>
        <b-modal no-enforce-focus id="modal_get" size="lg" :title="`Detail Form`" hide-footer>
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-3">Oleh:</div>
                        <div class="col-md-9">{{ dataModal.nama }}</div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-3">Judul:</div>
                        <div class="col-md-9">{{ dataModal.judul }}</div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-3">Isi:</div>
                        <div class="col-md-9">{{ dataModal.isi }}</div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-3">Lampiran:</div>
                        <div class="col-md-9"><a :href="`${$endpoint}uploads/forum_alumni/${dataModal.lampiran}`">{{ dataModal.lampiran }}</a></div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<style scoped>
  .cursor-hand{
    cursor: pointer;
    color: blue;
    text-decoration: underline;
  }
</style>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import ButtonComponent from '@/view/content/components/button/buttonComponent.vue';
import axios from "axios";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {

    data(){
        return{
            lampiran : null,
            headers_forum : [
                {text : "No",       value : "no"},
                {text : "NOAK/NRP", value : "nim"},
                {text : "Nama",     value : "nama"},
                {text : "Judul",    value : "judul"},
                {text : "Lampiran", value : "lampiran"},
                {text : "Action", value : "action"}
            ],

            forum_alumni : [],
            dataModal: {
                nama        : '',
                judul       : '',
                isi         : '',
                lampiran    : ''
            }
        }
    },

    components : {
        KTCodePreview,
        ButtonComponent
    },

    async mounted(){
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Forum Alumni" },
        ]),
        this.getForumAlumni()
    },

    methods : {
        async getForumAlumni(){
            try{

                await axios.get('forum-alumni/alumni/general').then(response => {
                    if(response.status == 200){
                        response.data.data.some( (e,index) => {

                            var object = {
                                no          : index + 1,
                                nim         : e.nim,
                                nama        : e.nama,
                                judul       : e.judul,
                                lampiran    : e.lampiran,
                                isi         : e.isi
                            }

                            this.forum_alumni.push(object);
                            return index > e.length;  
                        })
                    }
                })

            }catch(error){
                this.$swal('Failed');
            }
        },

        downloadItem(label) {
            const externalRouteUrl = this.$endpoint + 'uploads/forum_alumni/' + label;
            window.open(externalRouteUrl, '_blank');
        },

        openModal(item){
            this.dataModal.nama     = item.nama;
            this.dataModal.judul    = item.judul;
            this.dataModal.isi      = item.isi;
            this.dataModal.lampiran = item.lampiran;
        }
    }
}

</script>